import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type CardDragFragment = (
  { __typename: 'Card' }
  & Pick<Types.Card, 'id' | 'cardRole' | 'name' | 'pos'>
);

export const CardDragFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CardDrag' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Card' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cardRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pos' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseCardDragFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<CardDragFragment, Apollo.OperationVariables>,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseCardDragFragmentResult
  extends Omit<Apollo.UseFragmentResult<CardDragFragment>, 'data'> {
  data?: CardDragFragment;
}

export const useCardDragFragment = ({
  from,
  returnPartialData,
  ...options
}: UseCardDragFragmentOptions): UseCardDragFragmentResult => {
  const result = Apollo.useFragment<CardDragFragment>({
    ...options,
    fragment: CardDragFragmentDoc,
    fragmentName: 'CardDrag',
    from: {
      __typename: 'Card',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as CardDragFragment };
};
